import type { FaireProductEntity } from "../../entity_types/product";

export const p_sxzg8haxcc: FaireProductEntity = {
  token: "p_sxzg8haxcc",
  type: "product",
  name: "Windchime - Sea Glass, Lotus Pink",
  brandToken: "b_brgwq19hx1",
  brandName: "Earths Elements Wholesale",
  imageUrl:
    "https://cdn.faire.com/fastly/73ce77df546dec05fc1de913be4a74dfb1a398abb6e857812b85e2e45dd202ec.jpeg",
  galleryImageUrls: [],
  priceDollars: 11.78,
  description:
    "WC-SLTP\nWindchime - Sea Glass, Lotus Pink\nMade in Indonesia\nMin. 2\n\nElegant and soothing, this Sea Glass Lotus Windchime showcases a graceful lotus design accented with soft pink sea glass pieces. The gentle hues and flowing shape create a calming visual as each piece moves delicately with the breeze, catching light and adding a subtle shimmer.\n\nHandcrafted in Indonesia, these recycled sea glass wind chimes are eco-friendly decorative pieces that combine colorful, tumbled recycled glass with locally sourced driftwood. Mostly produced in Bali, the chimes feature frosted, hand-cut glass suspended on nylon lines, creating gentle, melodic sounds.",
  tags: [],
  msrpDollars: 23.56,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:58.555Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
